//load Kerv analytics pixel

export function loadKerv() {
  //these are required parameters - get an error if undefined
  if (window) {
    window.k_param_order = '';
    window.k_param_a = '';
  }

  const kervScript = document.createElement('script');
  kervScript.onload = () => {
    if (kervPixelMain58) {
      kervPixelMain58();
    }
  };
  const otherScript = document.getElementsByTagName('script')[0];
  otherScript.parentNode.insertBefore(kervScript, otherScript);
  kervScript.src = 'https://rcdn.kervinteractive.com/pixels/58.js';
  kervScript.type = 'text/javascript';
}
